import React, { useMemo } from 'react';
import { createGrowthModelHttpApi } from '../../../api/services/growth-model-http-api';
import { GrowthModelProviderWithApi } from './GrowthModelProvider';
import GrowthModelView from './GrowthModelView';

const apiBase =
	(typeof window !== 'undefined' && (window as any).__GROWTH_E2E_API__) ||
	process.env.REACT_APP_GROWTH_E2E_API_URL ||
	'http://127.0.0.1:4188';

const GrowthModelE2EPage: React.FC = () => {
	const api = useMemo(() => createGrowthModelHttpApi(apiBase), []);
	return (
		<div data-testid="growth-model-e2e-shell" style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
			<header
				data-testid="growth-model-e2e-auth-shell"
				style={{
					height: 48,
					display: 'flex',
					alignItems: 'center',
					padding: '0 16px',
					borderBottom: '1px solid #C8D4EA',
					background: '#fff',
					fontFamily: 'Segoe UI, sans-serif',
					color: '#0B1B33',
					gap: 12,
				}}
			>
				<strong>CX Data</strong>
				<span style={{ color: '#4D6389' }}>Authenticated shell · Growth Model e2e</span>
			</header>
			<div style={{ flex: 1, minHeight: 0 }}>
				<GrowthModelProviderWithApi api={api}>
					<GrowthModelView />
				</GrowthModelProviderWithApi>
			</div>
		</div>
	);
};

export default GrowthModelE2EPage;
